import React from 'react'

const LawText = () => {
  return (
   <></>
  )
}

export default LawText
